import { useEffect, useState } from "react";
import { Client } from "@twilio/conversations";
import CareMessages from "./CareMessages";
import { CareMessageClientStatus } from "../../../models/pages/care-messages.model";
import TwilioConversationService from "../../../services/twilio/twilio-conversations.service";
import { getLocalStorageUser } from "../../../services/session/auth.service";

const CareMessagesClient = () => {
	const [clientState, setClientState] = useState<CareMessageClientStatus>(
		CareMessageClientStatus.LOADING
	);

	useEffect(() => {
		// Listen to the SDK client changes
		const clientSubscription = TwilioConversationService.clientSubject.subscribe(
			(event: Client | null) => {
				if (event && event.connectionState === "connected") {
					setClientState(CareMessageClientStatus.SUCCESS);
				} else if (
					event?.connectionState === "denied" ||
					event?.connectionState === "disconnected" ||
					event?.connectionState === "disconnecting" ||
					event?.connectionState === "error"
				) {
					setClientState(CareMessageClientStatus.ERROR);
				}
			}
		);

		// Init SDK client + get the conversation
		initializeTwilioConversations();

		// Remove listeners
		return () => {
			if (clientSubscription) clientSubscription.unsubscribe();
		};
	}, []);

	const initializeTwilioConversations = async (): Promise<void> => {
		await TwilioConversationService.initializeClient();
		await TwilioConversationService.getConversation(getLocalStorageUser().id);
	};

	return <CareMessages clientState={clientState} />;
};
export default CareMessagesClient;
